import imageCompression from "browser-image-compression"
import { graphQLErrorType, hasBackendErr } from "../../../shared/requests/requestsUtility"
import { getInitials } from "../../../shared/utility"
import { userType } from "../../../shared/localStorage"

// Compress an image as close as possible to the fileSize passed.
export const compressImage = async (file: File, fileSize: number): Promise<File> => {
  let compressedFile = file

  const options = {
    maxSizeMB: fileSize,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  }

  try {
    const compressed = await imageCompression(file, options)
    // Convert Blob to File to maintain consistent return type.
    compressedFile = new File([compressed], file.name, { type: compressed.type })
  } catch (err) {
    console.log(err)
  }

  return compressedFile
}

// An array of strings to indicate wheather backendErrs are applicable to dropZone.
export const errTypes = ["icon", "profile_picture", "signS3", "putS3", "Unknown", "badge", "dropzone", "dropzoneBody", "dropzoneEmblem", "dropzoneLogo", "body", "logo", "emblem"]

// Determine if error class should be applied.
// If dropzoneErrorField is provided, only show errors matching that specific field.
export const displayError = (
  error: string,
  loading: boolean,
  backendErr?: graphQLErrorType,
  dropzoneErrorField?: string,
): boolean => {
  if (loading) {
    return false
  }

  // Always show local errors (file rejection errors).
  if (error) {
    return true
  }

  if (!backendErr) {
    return false
  }

  // If a specific error field is provided, only match that exact type.
  if (dropzoneErrorField) {
    return backendErr.type === dropzoneErrorField
  }

  // Fallback for DropZones without a specific error field - match any dropzone-related error.
  return hasBackendErr(errTypes, backendErr)
}

// Return more palatable dropZone errors.
export const formatError = (error: string): string => {
  switch (error) {
    case "File is larger than 10000000 bytes":
      return "File size is too big! 10 megabytes maximum."
    case "File type must be image/jpeg,image/png,image/avif,image/webp":
      return "The file type must be a jpeg, png, avif, or webp."
    case "Too many files":
      return "Woah there! Only one file buster."
    default:
      return error
  }
}

// Return thumbnail JSX
export const dropZoneThumb = (
  thumb: string,
  imgErr: boolean,
  setImgErr: React.Dispatch<React.SetStateAction<boolean>>,
  user?: userType,
  zoom?: number,
  objectFit: 'cover' | 'contain' = 'cover',
): JSX.Element => {
  if (imgErr && user) {
    return (
      <div className="dropzone-user-icon">
        <p>{getInitials(user.name)}</p>
      </div>
    )
  } else if (imgErr) {
    return (
      <div className="dropzone-image-error">
        <p>Err</p>
      </div>
    )
  } else {
    return (
      <img
        alt="Thumbnail"
        src={thumb}
        onError={() => setImgErr(true)}
        style={{
          width: zoom ? `${zoom}%` : "100%",
          height: zoom ? `${zoom}%` : "100%",
          objectFit,
        }}
      />
    )
  }
}